import createApi from 'api/createApi';

export const taskApi = createApi({
	reducerPath: 'mw/order/taskApi',

	endpoints: () => ({}),
});

export default taskApi;
